import { btnDelay } from "common/utils";

const CloseBtnSvg = () => (
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="#FEFDFE" d="M.667 5.11 5.11.668l22.222 22.222-4.444 4.444z" />
    <path fill="#FEFDFE" d="M5.11 27.334.668 22.89 22.889.667l4.444 4.444z" />
  </svg>
);

export const CloseBtn = (props: { close?: () => void }) => {
  const handleClose = () => {
    if (props.close) {
      btnDelay(() => props.close());
    }
  };
  return (
    <div className="flex-col-el z-[100] absolute -top-[44px] -right-[44px]">
      <div className="flex-col-el flex-center relative upsilon-circle border-solid overflow-visible rounded-full border-[8px] border-white bg-white">
        <button
          className="btn btn-danger !m-0 !rounded-full !border-0 overflow-visible"
          onClick={handleClose}
        >
          <div className="flex-col-el flex-center relative">
            <div className="flex-col-el flex-center relative w-[32px] h-[32px]">
              <CloseBtnSvg />
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export const CloseBtnOuter = (props: { close: () => void }) => {
  const handleClose = () => {
    btnDelay(() => props.close());
  };
  return (
    <div className="flex-col-el z-[100] absolute top-0 right-0">
      <div className="flex-col-el flex-center relative upsilon-circle overflow-visible rounded-full">
        <button
          className="btn btn-danger !m-0 !rounded-full !border-0 overflow-visible"
          onClick={handleClose}
        >
          <div className="flex-col-el flex-center relative">
            <div className="flex-col-el flex-center relative w-[32px] h-[32px]">
              <CloseBtnSvg />
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export const CloseBtnSmall = (props: { close?: () => void }) => {
  const handleClose = () => {
    if (props.close) {
      btnDelay(() => props.close());
    }
  };
  return (
    <div className="flex-col-el z-[100] absolute top-0 right-0">
      <div className="flex-col-el flex-center relative upsilon-circle border-solid overflow-visible rounded-full border-4 border-white bg-white">
        <button
          className="btn btn-danger !m-0 !rounded-full !border-0 overflow-visible"
          onClick={handleClose}
        >
          <div className="flex-col-el flex-center relative">
            <div className="flex-col-el flex-center relative w-[18px] h-[18px]">
              <CloseBtnSvg />
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export const ParentCloseBtn = (props: { close?: () => void }) => {
  const handleClose = () => {
    if (props.close) {
      btnDelay(() => props.close());
    }
  };
  return (
    <button
      className="group absolute top-4 right-4 z-[100] flex items-center justify-center w-10 h-10 rounded-full bg-gray2-40 hover:bg-red-20 border-none cursor-pointer transition-all"
      onClick={handleClose}
    >
      <span className="material-symbols-outlined !text-2xl text-gray2-100 group-hover:text-red-100 transition-colors">
        close
      </span>
    </button>
  );
};
